import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import _ from 'lodash';
import { t } from 'utils/translates';
import {
  changeFieldTitle,
  changeFieldTypeId,
  changeFieldLocaleCode,
  changeFieldRandomLink,
  changeFieldDesc,
  changeFieldAdultContent,
  changeFieldSoftwareInstall
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import {
  selectAllErrors,
  selectFieldTitle,
  selectFieldTypeId,
  selectFieldLocaleCode,
  selectFieldRandomLink,
  selectFieldDesc,
  selectFieldAdultContent,
  selectFieldSoftwareInstall
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import {
  getItemFromRefList,
  getValueFromRefDataModules
} from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';

import DefaultSelect from 'components/Common/Inputs/DefaultSelect';
import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';

import TasksLinksInputBlock from './TasksLinksInputBlock';

// eslint-disable-next-line react/prefer-stateless-function
class DescTaskInputs extends Component {
  constructor(props) {
    super(props);
    this.inputsRefs = {
      [props.fieldTitle.field]: React.createRef(),
      [props.fieldTypeId.field]: React.createRef(),
      [props.fieldLocaleCode.field]: React.createRef(),
      [props.fieldDesc.field]: React.createRef(),
      [props.fieldRandomLink.field]: React.createRef(),
      [props.fieldAdultContent.field]: React.createRef(),
      [props.fieldSoftwareInstall.field]: React.createRef()
    };
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    $(`#collapseDescription`).collapse('show');
  }

  componentDidUpdate(prevProps) {
    if (_.isEmpty(prevProps.allErrors) && !_.isEmpty(this.props.allErrors)) {
      const firstErrorField = Object.keys(this.props.allErrors)[0];
      const scrollRef = this.inputsRefs[firstErrorField];
      if (scrollRef && scrollRef.current) {
        scrollRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
            <small className="divider" />
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <React.Fragment>
        <div
          aria-multiselectable="true"
          className="panel-group"
          id="panelGroupDesc"
          role="tablist"
        >
          <section className="panel panel-heading_padding-large panel-body_bg-sub panel-default">
            <div className="panel-heading" role="tab">
              <h2 className="panel-title">
                <a
                  aria-controls="filter-collapseDescription"
                  aria-expanded="true"
                  className="dropdown-toggle dropdown-toggle-collapse collapsed"
                  data-toggle="collapse"
                  href="#collapseDescription"
                  role="button"
                >
                  <i className="fa fa-info-circle fa-fw" />{' '}
                  {t('Описание задачи')}
                </a>
              </h2>
            </div>
            <div
              aria-labelledby="headingOne"
              className="panel-collapse collapse"
              id="collapseDescription"
              role="tabpanel"
              aria-expanded="true"
            >
              <div className="panel-body">
                <form className="ng-pristine ng-invalid ng-touched">
                  <div className="row">
                    <div className="col-xs-24 col-sm-24 col-md-24">
                      <div
                        className={`form-group ${
                          hasError(this.props.fieldTitle.errors)
                            ? 'has-error'
                            : ''
                        }`}
                      >
                        <label className="control-label" htmlFor="title">
                          {t('Название')}
                        </label>
                        <input
                          ref={this.inputsRefs[this.props.fieldTitle.field]}
                          className="form-control"
                          id="title"
                          placeholder={t('Название')}
                          type="text"
                          value={this.props.fieldTitle.value}
                          onChange={e => {
                            this.props.changeFieldTitle(e.target.value);
                          }}
                        />
                        {errorDesc(this.props.fieldTitle.errors)}
                        <small className="help-block">
                          {t(
                            'Короткое название (5 символов минимум), передающее суть задания.'
                          )}
                        </small>
                      </div>
                    </div>
                    <div className="col-xs-24 col-sm-12 col-md-12">
                      <div
                        className={`form-group ${
                          hasError(this.props.fieldTypeId.errors)
                            ? 'has-error'
                            : ''
                        }`}
                      >
                        <label className="control-label" htmlFor="taskType2">
                          {t('Категория')}
                        </label>
                        <DefaultSelect
                          ref={this.inputsRefs[this.props.fieldTypeId.field]}
                          selectArrItems={this.props.taskTypes.reduce(
                            (result, item) => {
                              if (item.status === 1) {
                                result.push({
                                  value: item.value,
                                  title: item.title
                                });
                              }
                              return result;
                            },
                            []
                          )}
                          value={this.props.fieldTypeId.value}
                          handleChangeValue={value => {
                            this.props.changeFieldTypeId(value);
                          }}
                        />
                        {errorDesc(this.props.fieldTypeId.errors)}
                        <small className="help-block">
                          {t(
                            'Внимательно выбирайте категорию <strong>За неверное определение типа можно получить ЧБ</strong>'
                          )}
                          .{' '}
                        </small>
                      </div>
                    </div>
                    <div className="col-xs-24 col-sm-12 col-md-12">
                      <div
                        className={`form-group ${
                          hasError(this.props.fieldLocaleCode.errors)
                            ? 'has-error'
                            : ''
                        }`}
                      >
                        <label className="control-label" htmlFor="language">
                          {t('Язык')}
                        </label>
                        <DefaultSelect
                          ref={
                            this.inputsRefs[this.props.fieldLocaleCode.field]
                          }
                          selectArrItems={Object.keys(
                            this.props.taskLocaleCodes
                          ).map(key => ({
                            value: key,
                            title: this.props.taskLocaleCodes[key]
                          }))}
                          selectTitleNullValue={false}
                          value={this.props.fieldLocaleCode.value}
                          handleChangeValue={value => {
                            this.props.changeFieldLocaleCode(value);
                          }}
                        />
                        {errorDesc(this.props.fieldLocaleCode.errors)}
                        <small className="help-block">{t('Язык')}</small>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-24 col-sm-12 col-md-12">
                      <TasksLinksInputBlock {...this.props} />
                    </div>
                    <div className="col-xs-24 col-sm-12 col-md-12">
                      <div className="form-group">
                        <label className="control-label" htmlFor="linking">
                          {t('Переход по ссылкам')}
                        </label>
                        <DefaultSelect
                          ref={
                            this.inputsRefs[this.props.fieldRandomLink.field]
                          }
                          selectArrItems={this.props.linkBehavior.map(
                            (v, k) => ({
                              value: k,
                              title: v
                            })
                          )}
                          selectTitleNullValue={null}
                          value={this.props.fieldRandomLink.value}
                          handleChangeValue={value => {
                            this.props.changeFieldRandomLink(value);
                          }}
                        />
                        <small className="help-block">
                          {t(
                            'Выбирать ссылки для перехода пользователям в случайном порядке или по очереди'
                          )}
                          .
                        </small>
                      </div>
                    </div>
                    <div className="col-xs-24 col-sm-24 col-md-24">
                      <div
                        className={`form-group m-b-0 ${
                          hasError(this.props.fieldDesc.errors)
                            ? 'has-error'
                            : ''
                        }`}
                      >
                        <label className="control-label" htmlFor="description">
                          {t('Описание')}
                        </label>
                        <textarea
                          ref={this.inputsRefs[this.props.fieldDesc.field]}
                          className="form-control"
                          id="description"
                          value={this.props.fieldDesc.value}
                          onChange={e => {
                            this.props.changeFieldDesc(e.target.value);
                          }}
                          minLength="5"
                          name="description"
                          rows="9"
                        />
                        {errorDesc(this.props.fieldDesc.errors)}
                        <small className="help-block">
                          {t(
                            '<strong>Распишите по пунктам</strong>, что должен сделать пользователь, не меньше 5 символов'
                          )}
                          .
                        </small>
                      </div>
                    </div>
                    <div className="col-xs-24 col-sm-12 col-md-12 m-b-10">
                      <div className="checkbox abc-checkbox abc-checkbox-primary">
                        <input
                          ref={
                            this.inputsRefs[this.props.fieldAdultContent.field]
                          }
                          className="styled"
                          id="checkbox1"
                          type="checkbox"
                          checked={
                            this.props.fieldAdultContent.value === '1'
                              ? 'checked'
                              : ''
                          }
                          onChange={() =>
                            this.props.changeFieldAdultContent(
                              this.props.fieldAdultContent.value === '1'
                                ? '0'
                                : '1'
                            )
                          }
                        />
                        <label htmlFor="checkbox1">
                          <div className="text-strong m-b-4">
                            {t('Для взрослых')}
                          </div>
                          {t(
                            'Необходимо отметить, если ваш сайт только для совершеннолетних (содержит: эротику, нецензурную лексику, алкогольные темы и другие материалы для взрослых). Запрещённые темы указаны в {link[label:правилах, пункт 4.2])}',
                            {
                              link: args => (
                                <PopUpLink
                                  hashName="fagContent"
                                  hashParams={{ id: 'communication_rules' }}
                                >
                                  {args.label}
                                </PopUpLink>
                              )
                            }
                          )}
                        </label>
                      </div>
                    </div>
                    <div className="col-xs-24 col-sm-12 col-md-12">
                      <div className="checkbox abc-checkbox abc-checkbox-primary">
                        <input
                          ref={
                            this.inputsRefs[
                              this.props.fieldSoftwareInstall.field
                            ]
                          }
                          className="styled"
                          id="checkbox2"
                          type="checkbox"
                          checked={
                            this.props.fieldSoftwareInstall.value === '1'
                              ? 'checked'
                              : ''
                          }
                          onChange={() =>
                            this.props.changeFieldSoftwareInstall(
                              this.props.fieldSoftwareInstall.value === '1'
                                ? '0'
                                : '1'
                            )
                          }
                        />
                        <label htmlFor="checkbox2">
                          <div className="text-strong m-b-4">
                            {t('Установка ПО, Опасность')}
                          </div>
                          {t(
                            'Необходимо отметить, если в процессе выполнения задания требуется (или предлагается) установка какого либо ПО, плагинов, расширений и т.д. <span class="text-danger"> Распространение вирусов запрещено!</span>'
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

DescTaskInputs.propTypes = {
  fieldTitle: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldTypeId: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldLocaleCode: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldRandomLink: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldDesc: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldAdultContent: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldSoftwareInstall: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  allErrors: PropTypes.shape({}).isRequired,
  changeFieldTitle: PropTypes.func.isRequired,
  changeFieldTypeId: PropTypes.func.isRequired,
  changeFieldLocaleCode: PropTypes.func.isRequired,
  changeFieldRandomLink: PropTypes.func.isRequired,
  changeFieldDesc: PropTypes.func.isRequired,
  changeFieldAdultContent: PropTypes.func.isRequired,
  changeFieldSoftwareInstall: PropTypes.func.isRequired,
  taskTypes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  taskLocaleCodes: PropTypes.shape({}).isRequired,
  linkBehavior: PropTypes.arrayOf(PropTypes.string).isRequired
};

const mapStateToProps = (state, props) => ({
  fieldTitle: selectFieldTitle(state, props.reducerName),
  fieldTypeId: selectFieldTypeId(state, props.reducerName),
  fieldLocaleCode: selectFieldLocaleCode(state, props.reducerName),
  fieldRandomLink: selectFieldRandomLink(state, props.reducerName),
  fieldDesc: selectFieldDesc(state, props.reducerName),
  fieldAdultContent: selectFieldAdultContent(state, props.reducerName),
  fieldSoftwareInstall: selectFieldSoftwareInstall(state, props.reducerName),
  allErrors: selectAllErrors(state, props.reducerName),
  taskTypes: getValueFromRefDataModules(state, 'tasks.taskTypes'),
  taskLocaleCodes: getItemFromRefList(state, 'taskLocaleCodes'),
  linkBehavior: getItemFromRefList(state, 'linkBehavior')
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldTitle: value =>
    dispatch(changeFieldTitle(props.reducerName, value)),
  changeFieldTypeId: value =>
    dispatch(changeFieldTypeId(props.reducerName, value)),
  changeFieldLocaleCode: value =>
    dispatch(changeFieldLocaleCode(props.reducerName, value)),
  changeFieldRandomLink: value =>
    dispatch(changeFieldRandomLink(props.reducerName, value)),
  changeFieldDesc: value => dispatch(changeFieldDesc(props.reducerName, value)),
  changeFieldAdultContent: value =>
    dispatch(changeFieldAdultContent(props.reducerName, value)),
  changeFieldSoftwareInstall: value =>
    dispatch(changeFieldSoftwareInstall(props.reducerName, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DescTaskInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/DescTaskInputs/DescTaskInputs.js